import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import Header from './comp/Header';
import Vision from './comp/Vision';
import About from './comp/About';
import Contact from './comp/Contact';
import Services from './comp/Services';
import Journey from './comp/Journey';
import Footer from './comp/Footer';
import API from '../../api';
import Slider from './comp/Slider';

const Home = () => {
  const [appData, setAppData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const readAppData = async () => {
    try {
      setIsLoading(true);
      const response = await API.get(`/configurations/meta-details`);
      if (response.data) {
        setAppData(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    readAppData();
  }, []);

  return (
    <>
      <MetaTags>
        <link
          href="https://fonts.googleapis.com/css?family=Poppins:200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap"
          rel="stylesheet"
        />

        <link rel="stylesheet" href="css/bootstrap.min.css" />
        <link rel="stylesheet" href="css/normalize.css" />
        <link rel="stylesheet" href="css/style.css" />
        <link rel="stylesheet" href="css/responsive.css" />
        <link rel="stylesheet" href="css/color/color1.css" />
        <link rel="stylesheet" id="colors" />
      </MetaTags>
      {isLoading ? (
        <>
          <p>Loading...</p>
        </>
      ) : (
        <>
          <Header {...appData} />
          <Slider {...appData} />
          <Vision {...appData} />
          <About {...appData} />
          <Contact {...appData} />
          <Services />
          <Journey />
          <Footer {...appData} />
        </>
      )}

      <script src="js/jquery.min.js"></script>
      <script src="js/bootstrap.min.js"></script>
      <script src="js/main.js"></script>
    </>
  );
};

export default Home;
